<template>
  <b-overlay
      :show="users === null"
      rounded="sm"
  >
    <div v-if="users !== null">
      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>

            <!-- Search -->
            <b-col
                cols="12"
                md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    placeholder="جستجو..."
                />
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="users"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >

          <template #cell(userId)="data">
            <b-media vertical-align="center">
              <b-link
                  :to="{ name: 'apps-block-user', params: { id: data.item.userId } }"
                  class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.name+' '+data.item.familyName }}
              </b-link>
              <small class="text-muted">@{{ data.item.userId }}</small>
            </b-media>
          </template>

          <!-- Column: type -->
          <template #cell(type)="data">
            <b-badge
                pill
                class="text-capitalize"
                :variant="``"
            >
              {{ data.item.type }}
            </b-badge>
          </template>

          <!-- Column: edit -->
          <template #cell(select)="data">
            <b-link :to="{ name: 'apps-block-user', params: { id: data.item.userId } }">
              <feather-icon icon="EditIcon" size="20"/>
            </b-link>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <QueriedPagination v-if="totalCounts" v-model="currentPage" :total-counts="totalCounts"
                                 :per-page="perPage"></QueriedPagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BMedia, BLink,
  BBadge, BPagination, BOverlay
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {UserProductBlockGetAllUserRequest} from "@/libs/Api/UserProductBlock";
import {UsersGetAllRequest} from "@/libs/Api/Users";
import QueriedPagination from "@/views/components/QueriedPagination.vue";

export default {
  name:'Block',
  title:"مسدود سازی - پنل ادمین لنزآوا",
  data(){
    return{
      users:null,
      currentPage:1,
      totalCounts:null,
      perPage:10,
      perState:'',
      perStateOptions:[
        {label:'همه',value:''},
        {label:'وارد شده',value:1},
        {label:'فالو نکرده',value:2},
        {label:'آیدی اشتباه',value:3}
      ],
      perPageOptions:[10, 20, 30 , 40 , 50],
      myTableColumns : [
        { key: 'userId' ,label :'نام کامل'},
        { key: 'instagramId' ,label :'اینستاگرام'},
        { key: 'nationalId' ,label :'کد ملی'},
        { key: 'mobile',label: 'موبایل'},
        { key: 'select',label:'انتخاب کاربر'},
      ],
      searchQuery:'',
      isAddNewUserSidebarActive:false,
    }
  },
  async created() {
    if (this.$route.query.pageNumber) {
      this.currentPage = +this.$route.query.pageNumber
    }
    await this.getUsers()
  },
  methods:{
    refreshData(){
      this.getUsers()
    },
    async getUsers(count,pageNumber,search,state){
      let _this = this;
      let data = {
        pageNumber: _this.currentPage,
        count:_this.perPage,
        search: _this.searchQuery,
        state: _this.perState,
      }

      let userProductBlockGetAllUserRequest = new UsersGetAllRequest(_this);
      userProductBlockGetAllUserRequest.setParams(data);
      await userProductBlockGetAllUserRequest.fetch(function (content){
         _this.users = content.users;
        _this.totalCounts = content.usersCount;
      },function (error){
        console.log(error);
      })
    }
  },
  watch:{
    perPage: function (nv, ov) {
      this.getUsers();
    },
    getQuery: function (nv, ov) {
      this.getUsers();
    },
    // currentPage: function (nv, ov) {
    //   this.getUsers();
    // },
    searchQuery: function (nv, ov) {
      this.getUsers();
    },
    perState: function (nv, ov) {
      this.getUsers();
    },
  },
  computed: {
    getQuery() {
      return this.$route.query
    },
  },
  components: {
    QueriedPagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BLink,
    BBadge,
    BPagination,
    BOverlay,

    vSelect,
  },
}
</script>

<style lang="scss" scoped>

</style>
